<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <h4>Εξαγωγή Ημερών Επιθεώρησης</h4>
        </CCardHeader>
        <CCardBody>
          <!-- Filters Section -->
          <CCard class="mb-4">
            <CCardHeader>
              <strong>Φίλτρα</strong>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Επιθεώρησης Από</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.date_from"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Επιθεώρησης Έως</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.date_to"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Πρότυπο (ISO)</label>
                    <multiselect
                      v-model="selectedServices"
                      :options="groupedServices"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Επιλέξτε πρότυπα"
                      label="name"
                      track-by="id"
                      group-values="services"
                      group-label="group"
                      :group-select="true"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Τύπος Επιθεώρησης</label>
                    <select class="form-control" v-model="filters.inspection_type">
                      <option value="">Όλοι</option>
                      <option v-for="(type, index) in inspectionTypes" :key="index" :value="index">
                        {{ type }}
                      </option>
                    </select>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="3">
                  <div class="form-group">
                    <label>Χώρα</label>
                    <select class="form-control" v-model="filters.country_id">
                      <option value="">Όλες</option>
                      <option v-for="country in countries" :key="country.id" :value="country.id">
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Πελάτης</label>
                    <select class="form-control" v-model="filters.client_id">
                      <option value="">Όλοι</option>
                      <option v-for="client in clients" :key="client.id" :value="client.id">
                        {{ client.company }}
                      </option>
                    </select>
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Επιθεωρητής</label>
                    <select class="form-control" v-model="filters.inspector_id">
                      <option value="">Όλοι</option>
                      <option v-for="inspector in inspectors" :key="inspector.id" :value="inspector.id">
                        {{ inspector.name }}
                      </option>
                    </select>
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ρόλος Επιθεωρητή</label>
                    <multiselect
                      v-model="selectedRoles"
                      :options="inspectorRoles"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Επιλέξτε ρόλους"
                      label="name"
                      track-by="id"
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="3">
                  <div class="form-group">
                    <label>Κατάσταση Υπόθεσης</label>
                    <multiselect
                      v-model="selectedStatuses"
                      :options="statuses"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Επιλέξτε καταστάσεις"
                      label="name"
                      track-by="id"
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CButton color="primary" @click="loadPreview" :disabled="loading">
                    <span v-if="loading">
                      <CSpinner size="sm" /> Φόρτωση...
                    </span>
                    <span v-else>Προεπισκόπηση</span>
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="clearFilters">
                    Καθαρισμός Φίλτρων
                  </CButton>
                  <CButton
                    color="success"
                    class="ml-2"
                    @click="exportToExcel"
                    :disabled="!hasData || loading"
                  >
                    Εξαγωγή σε Excel
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <!-- Summary -->
          <CAlert v-if="hasData" color="info" class="mb-4">
            <strong>Σύνοψη:</strong>
            {{ summary.total_clients }} πελάτες,
            {{ summary.total_cases }} υποθέσεις,
            {{ summary.total_inspection_days }} ημέρες επιθεώρησης
          </CAlert>

          <!-- Preview Table -->
          <CCard v-if="hasData">
            <CCardHeader>
              <strong>Προεπισκόπηση Δεδομένων</strong>
            </CCardHeader>
            <CCardBody>
              <CDataTable
                :items="data"
                :fields="tableFields"
                :items-per-page="15"
                hover
                pagination
                table-filter
                sorter
                clickable-rows
                @row-clicked="openCase"
              />
            </CCardBody>
          </CCard>

          <!-- No Data Message -->
          <CAlert v-if="loaded && !hasData" color="warning">
            Δεν βρέθηκαν υποθέσεις με τα επιλεγμένα φίλτρα.
          </CAlert>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

const tableFields = [
  { key: 'client_name', label: 'Πελάτης', sorter: true },
  { key: 'country_name', label: 'Χώρα', sorter: true },
  { key: 'service_group_name', label: 'Ομάδα', sorter: true },
  { key: 'service_name', label: 'Πρότυπο (ISO)', sorter: true },
  { key: 'case_code', label: 'Κωδικός Υπόθεσης', sorter: true },
  { key: 'certificate_no', label: 'Αρ. Πιστοποιητικού', sorter: true },
  { key: 'inspection_type', label: 'Τύπος Επιθεώρησης', sorter: true },
  { key: 'inspector_name', label: 'Επιθεωρητής', sorter: true },
  { key: 'inspection_date', label: 'Ημ/νία Επιθεώρησης', sorter: true },
  { key: 'days', label: 'Ημέρες', sorter: true },
  { key: 'status_name', label: 'Κατάσταση', sorter: true }
]

export default {
  name: 'ExportCaseDays',
  components: {
    Multiselect
  },
  data() {
    return {
      loading: false,
      loaded: false,
      filters: {
        date_from: '',
        date_to: '',
        inspection_type: '',
        country_id: '',
        client_id: '',
        inspector_id: ''
      },
      services: [],
      countries: [],
      clients: [],
      inspectors: [],
      inspectorRoles: [],
      statuses: [],
      selectedServices: [],
      selectedRoles: [],
      selectedStatuses: [],
      inspectionTypes: [
        'Αρχική επιθεώρηση',
        '1η επιτήρηση',
        '2η επιτήρηση',
        'Επαναξιολόγηση',
        'Ειδική Επιθεώρηση'
      ],
      data: [],
      summary: {
        total_clients: 0,
        total_cases: 0,
        total_inspection_days: 0
      },
      tableFields
    }
  },
  computed: {
    hasData() {
      return this.data && this.data.length > 0
    },
    groupedServices() {
      const groups = {}
      this.services.forEach(service => {
        const groupName = service.group || 'Χωρίς ομάδα'
        if (!groups[groupName]) {
          groups[groupName] = []
        }
        groups[groupName].push(service)
      })
      return Object.keys(groups).map(group => ({
        group: group,
        services: groups[group]
      }))
    }
  },
  methods: {
    async loadFilterOptions() {
      try {
        const response = await axios.get('/api/case-days-export/filter-options', {
          params: { token: localStorage.getItem('api_token') }
        })
        this.services = response.data.services || []
        this.countries = response.data.countries || []
        this.clients = response.data.clients || []
        this.inspectors = response.data.inspectors || []
        this.inspectorRoles = response.data.inspector_roles || []
        this.statuses = response.data.statuses || []
        // Set default status to "Ολοκληρωμένη" (Completed)
        const completedStatus = this.statuses.find(s => s.name === 'Ολοκληρωμένη')
        if (completedStatus && this.selectedStatuses.length === 0) {
          this.selectedStatuses = [completedStatus]
        }
      } catch (error) {
        console.error('Error loading filter options:', error)
      }
    },
    async loadPreview() {
      this.loading = true
      try {
        const params = {
          token: localStorage.getItem('api_token'),
          ...this.filters
        }
        // Handle service_ids from multiselect
        if (this.selectedServices && this.selectedServices.length > 0) {
          params.service_ids = this.selectedServices.map(s => s.id).join(',')
        }
        delete params.service_ids_array
        // Handle inspector_role_ids from multiselect
        if (this.selectedRoles && this.selectedRoles.length > 0) {
          params.inspector_role_ids = this.selectedRoles.map(r => r.id).join(',')
        }
        delete params.inspector_role_ids_array
        // Handle status_ids from multiselect
        if (this.selectedStatuses && this.selectedStatuses.length > 0) {
          params.status_ids = this.selectedStatuses.map(s => s.id).join(',')
        }
        // Remove empty filters
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || (Array.isArray(params[key]) && params[key].length === 0)) {
            delete params[key]
          }
        })

        const response = await axios.get('/api/case-days-export/preview', { params })
        this.data = response.data.data || []
        this.summary = response.data.summary || { total_clients: 0, total_cases: 0, total_inspection_days: 0 }
        this.loaded = true
      } catch (error) {
        console.error('Error loading preview:', error)
        if (error.response && error.response.status === 401) {
          this.$router.push({ path: '/login' })
        }
      } finally {
        this.loading = false
      }
    },
    clearFilters() {
      this.filters = {
        date_from: '',
        date_to: '',
        inspection_type: '',
        country_id: '',
        client_id: '',
        inspector_id: ''
      }
      this.selectedServices = []
      this.selectedRoles = []
      this.selectedStatuses = []
    },
    openCase(item) {
      const routeData = this.$router.resolve({ path: `/cases/${item.case_id}` })
      window.open(routeData.href, '_blank')
    },
    exportToExcel() {
      if (!this.hasData) return

      // Create workbook
      const wb = XLSX.utils.book_new()

      // Headers
      const headers = [
        'Πελάτης',
        'Χώρα',
        'Ομάδα',
        'Πρότυπο (ISO)',
        'Κωδικός Υπόθεσης',
        'Αρ. Πιστοποιητικού',
        'Τύπος Επιθεώρησης',
        'Επιθεωρητής',
        'Ημ/νία Επιθεώρησης',
        'Ημέρες',
        'Κατάσταση'
      ]

      // Data rows
      const rows = this.data.map(row => [
        row.client_name,
        row.country_name,
        row.service_group_name,
        row.service_name,
        row.case_code,
        row.certificate_no,
        row.inspection_type,
        row.inspector_name,
        row.inspection_date,
        row.days,
        row.status_name
      ])

      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
      XLSX.utils.book_append_sheet(wb, ws, 'Ημέρες Επιθεώρησης')

      // Generate filename with date
      const today = new Date().toISOString().slice(0, 10)
      const filename = `case_inspection_days_${today}.xlsx`

      // Download
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

      function s2ab(s) {
        const buf = new ArrayBuffer(s.length)
        const view = new Uint8Array(buf)
        for (let i = 0; i < s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xFF
        }
        return buf
      }

      const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
  },
  mounted() {
    this.loadFilterOptions()
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mb-4 {
  margin-bottom: 1.5rem;
}
/deep/ table tbody tr {
  cursor: pointer;
}
</style>
